import React from "react";

export const LOGIN = React.lazy(() => import('../components/Pages/Login.jsx'));
export const MainPage = React.lazy(() => import('../components/Pages/Agent/MainPage.js'));
// export const PRODUCT = React.lazy(() => import('../components/Pages/Product.js'));
export const PRODUCT = React.lazy(() => import('../components/OldComponents/HomePage.js'));
